// extracted by mini-css-extract-plugin
export default {"container":"ua1UvArijEcb7TjoKa2K","noCardText":"ROSEn6OAtsy5aE0lLmCA","smallText":"nLkybxBkj6gkXQMfZkD_"};